import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AwardsList from "./AwardsListe";
import StarofYearList from "./StarofYearList";



function StarofListMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <StarofYearList/>
            </BasicCard>
        </>
    )
}
export default StarofListMain;